import cn from 'classnames';
import React from 'react';
import { DH } from '../../../utils/DataHook';
import { initErrorMessage } from '../constants';
import * as s from '../styles.scss';

const ErrorMessage: React.FunctionComponent<{
  dataHook: string;
  message: string;
  isModalTheme: boolean;
}> = (props) => {
  const errorIcon = props.isModalTheme
    ? require('../../../assets/img/error-icon-modal.svg').default
    : require('../../../assets/img/error-icon.svg').default;

  return (
    <div
      role="alert"
      className={cn(s.generalError, props.isModalTheme && s.modal)}
    >
      <div className={s.generalErrorContent}>
        <img aria-hidden={true} className={s.circleIcon} src={errorIcon} />
        <span
          data-hook={props.dataHook}
          className={s.generalErrorText}
          title={props.message}
        >
          {props.message}
        </span>
      </div>
    </div>
  );
};
ErrorMessage.displayName = 'ErrorMessage';

export const InitErrorMessage: React.FunctionComponent<{
  isModalTheme: boolean;
}> = (props) => (
  <ErrorMessage
    {...props}
    message={initErrorMessage}
    dataHook={DH.InitErrorMessage}
  />
);
InitErrorMessage.displayName = 'InitErrorMessage';

export const PaymentErrorMessage: React.FunctionComponent<{
  message: string;
  isModalTheme: boolean;
}> = (props) => <ErrorMessage {...props} dataHook={DH.PaymentErrorMessage} />;
PaymentErrorMessage.displayName = 'PaymentErrorMessage';
